/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ArchiveEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoArchiveItemInput = {
    clientMutationId?: string | null;
    entitySlug: string;
    entityType: ArchiveEntityTypeEnum;
};
export type ArchiveActionsArchiveMutationVariables = {
    input: infoArchiveItemInput;
};
export type ArchiveActionsArchiveMutationResponse = {
    readonly infoArchiveItem: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ArchiveActionsArchiveMutation = {
    readonly response: ArchiveActionsArchiveMutationResponse;
    readonly variables: ArchiveActionsArchiveMutationVariables;
};



/*
mutation ArchiveActionsArchiveMutation(
  $input: infoArchiveItemInput!
) {
  infoArchiveItem(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoArchiveItemPayload",
    "kind": "LinkedField",
    "name": "infoArchiveItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveActionsArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchiveActionsArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "162d2b1a95a5d21da5e57cc3468a005f",
    "id": null,
    "metadata": {},
    "name": "ArchiveActionsArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation ArchiveActionsArchiveMutation(\n  $input: infoArchiveItemInput!\n) {\n  infoArchiveItem(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '170340f7b77913d8da0c16884da70571';
export default node;
